import { hash } from '@ember/helper';
import { service } from '@ember/service';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsMediaPartnerComponent extends Component {
  // Services
  @service data;

  // Defaults
  countryOptions = [];
  regionOptions = [];
  partnerTypeOptions = [];

  // Hooks
  constructor() {
    super(...arguments);

    this.countryOptions = this.data.getCategories({
      'filter[type]': 'COUNTRY',
    });
    this.regionOptions = this.data.getCategories({
      'filter[type]': 'PROVINCE',
    });
    this.partnerTypeOptions = this.data.getCategories({
      'filter[type]': 'P_TYPE_MEDIA',
    });
  }

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='name' />
            <fieldset.field @property='city' />
            <fieldset.field @property='cityEn' />
            <fieldset.field @property='street' />
            <fieldset.field @property='zipcode' />

            <fieldset.field
              @property='region'
              @type='select-record'
              @isSearchEnabled={{true}}
              @options={{this.regionOptions}}
            />

            <fieldset.field
              @property='country'
              @type='select-record'
              @isSearchEnabled={{true}}
              @options={{this.countryOptions}}
            />

            <fieldset.field @property='phone' />
            <fieldset.field @property='email' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='configuration' as |fieldset|>
            <fieldset.field
              @property='link'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
            />

            <fieldset.field
              @property='partnerType'
              @type='select-record'
              @options={{this.partnerTypeOptions}}
            />

            <fieldset.field @property='dgg' @type='checkbox' />
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
